import { jsxs, jsx } from "react/jsx-runtime";
import { createElement } from "react";
import { Icon } from "@zapier/zinnia-icons";
import { useHeaderContext } from "../Header.js";
import { SubmenuArticle } from "../SubmenuArticle/SubmenuArticle.js";
import { SubmenuList } from "../SubmenuList/SubmenuList.js";
import styles from "./Submenu.module.scss.js";
function Submenu(props) {
  const context = useHeaderContext();
  return /* @__PURE__ */ jsxs("div", { className: styles.root, children: [
    /* @__PURE__ */ jsxs("div", { className: styles.main, children: [
      /* @__PURE__ */ jsxs("div", { className: styles.mainContent, children: [
        /* @__PURE__ */ jsxs("div", { className: styles.header, children: [
          props.heading && /* @__PURE__ */ jsx("div", { className: styles.heading, children: props.heading }),
          props.description && /* @__PURE__ */ jsx("p", { className: styles.description, children: props.description })
        ] }),
        /* @__PURE__ */ jsx("div", { className: styles.sections, children: props.sections.map((section) => /* @__PURE__ */ createElement(
          SubmenuList,
          {
            ...section,
            key: section.heading,
            parent: props.label
          }
        )) })
      ] }),
      props.bottomLinks && props.bottomLinks.length > 0 && /* @__PURE__ */ jsx("div", { className: styles.footer, children: /* @__PURE__ */ jsx("ul", { className: styles.footerList, children: props.bottomLinks.map((link) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsxs(
        "a",
        {
          className: styles.footerLink,
          href: context.resolveURL(link.url),
          onClick: (e) => context.emitLinkClickEvent(e, {
            interaction_name: "header_submenu_bottom_link_click",
            custom_tracking_fields: {
              parent: props.label
            }
          }),
          ...link.openInNewTab && {
            target: "_blank",
            rel: "noreferrer"
          },
          children: [
            link.icon && /* @__PURE__ */ jsx(Icon, { name: link.icon, size: 14 }),
            /* @__PURE__ */ jsx("span", { children: link.label })
          ]
        }
      ) }, link.label)) }) })
    ] }),
    props.featuredBlocks && props.featuredBlocks.length > 0 && /* @__PURE__ */ jsx("aside", { className: styles.aside, children: props.featuredBlocks.map(
      (block) => block.type === "SubmenuList" ? /* @__PURE__ */ createElement(
        SubmenuList,
        {
          ...block,
          key: block.heading,
          parent: props.label
        }
      ) : block.type === "SubmenuArticle" ? /* @__PURE__ */ createElement(
        SubmenuArticle,
        {
          ...block,
          key: block.title,
          parent: props.label
        }
      ) : null
    ) })
  ] });
}
export {
  Submenu
};
